import actions from '../action/luckyMoney'
import CONSTANT from '../constant/luckyMoney'
export default {
    actions,
    state: {

    },
    getters: {

    },
    mutations: {
        [CONSTANT.LUCKYMONEY_JOINREDPACKAGE_SUCCESS] (state, data) {

        },
        [CONSTANT.LUCKYMONEY_JOINREDPACKAGE_ERROR] (state, e) {
        },
        [CONSTANT.LUCKYMONEY_GETLUCKYYMONEYDETAIL_SUCCESS] (state, data) {

        },
        [CONSTANT.LUCKYMONEY_GETLUCKYYMONEYDETAIL_ERROR] (state, e) {
        },
        [CONSTANT.LUCKYMONEY_GETLUCKYYMONEYRECORD_SUCCESS] (state, data) {

        },
        [CONSTANT.LUCKYMONEY_GETLUCKYYMONEYRECORD_ERROR] (state, e) {
        },
        /*yeoman-template-point-1*/


    }
}
